export const DEFAULT_COUNTRIES = [
  { code: "LB", label: "Lebanon", dialCode: "+961" },
  { code: "AE", label: "United Arab Emirates", dialCode: "+971" },
  { code: "SA", label: "Saudi Arabia", dialCode: "+966" },
  { code: "QA", label: "Qatar", dialCode: "+974" },
  { code: "KW", label: "Kuwait", dialCode: "+965" },
  { code: "JO", label: "Jordan", dialCode: "+962" },
  { code: "EG", label: "Egypt", dialCode: "+20" },
];

export const DELIVERY_FALLBACK_BUSINESS_PROFILE_TYPE_ID =
  "71edf324-bd32-4699-9ea3-475586681c2c";
export const DELIVERY_FALLBACK_BUSINESS_PROFILE_CATEGORY_ID =
  "2d8d7354-1ddd-47d4-9d9b-c3b5ffd7c8c5";

export const BUSINESS_PROFILE_FALLBACKS = {
  Restaurant: {
    typeId: "4c5221cb-b38b-4d58-b308-b5e781e1333a",
    categoryId: "277022db-c089-4061-be42-31f58d67f8f6",
  },
  Grocery: {
    typeId: "9c079c0f-2b2b-44b4-be96-2fc9657a07d2",
    categoryId: "a0fb8c1b-3a87-44b2-87a5-379862bf44d1",
  },
  Cosmetics: {
    typeId: "34d6c154-0b81-4aa7-aa3a-f1315a36f0bf",
    categoryId: "5cc57544-e233-4f23-b33b-5827eb3d49b9",
  },
  Other: {
    typeId: DELIVERY_FALLBACK_BUSINESS_PROFILE_TYPE_ID,
    categoryId: DELIVERY_FALLBACK_BUSINESS_PROFILE_CATEGORY_ID,
  },
};

export const DELIVERY_TYPE_OPTIONS = [
  // { label: "Delivery Company", value: "DELIVERY_COMPANY" },
  { label: "Independent Driver", value: "INDIVIDUAL_DRIVER" },
];

export const GROCERY_CATEGORIES = [
  "Fruits / Vegetables",
  "Beverage",
  "Alcohol",
  "Snacks",
  "Meat / Chicken",
  "Dairy / Milk",
  "Stationary",
];

export const CUISINE_SECTIONS = [
  {
    id: "european",
    title: "European Cuisines",
    items: [
      { id: "italian", label: "Italian - Pasta, pizza, risotto", badge: "IT" },
      {
        id: "french",
        label: "French - Pastries, sauces, fine dining",
        badge: "FR",
      },
    ],
  },
  {
    id: "asian",
    title: "Asian Cuisines",
    items: [
      {
        id: "chinese",
        label: "Chinese - Stir fries, noodles, dumplings",
        badge: "CN",
      },
      { id: "japanese", label: "Japanese - Sushi, ramen, bento", badge: "JP" },
    ],
  },
  {
    id: "middleEastern",
    title: "Middle eastern & Arab Cuisines",
    items: [
      {
        id: "lebanese",
        label: "Lebanese - Mezza, hummus, tabbouleh",
        badge: "LB",
      },
      { id: "turkish", label: "Turkish - Kebabs, baklava", badge: "TR" },
    ],
  },
  {
    id: "american",
    title: "American Cuisines",
    items: [
      { id: "americanClassic", label: "America - Burgers, BBQ", badge: "US" },
      { id: "mexican", label: "Mexican - Tacos, burrito", badge: "MX" },
    ],
  },
  {
    id: "other",
    title: "Other Cuisine Categories",
    items: [
      { id: "vegetarian", label: "Vegetarian / Vegan", badge: "VG" },
      { id: "fastFood", label: "Fast Food", badge: "FF" },
    ],
  },
];

export const isSuccessResponse = (response) =>
  response?.status === 200 ||
  response?.status === 201 ||
  response?.status === 204;

export const isApiError = (response) =>
  response instanceof Error || response?.isAxiosError || response?.response;

export const getErrorMessage = (error, fallback = "Something went wrong.") =>
  String(
    error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.data?.message ||
      error?.data?.error ||
      error?.message ||
      fallback,
  );

export const toBooleanLike = (value) => {
  if (value === true || value === false) return value;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (["true", "yes", "1", "exists", "in use"].includes(normalized))
      return true;
    if (["false", "no", "0", "available"].includes(normalized)) return false;
  }
  if (value && typeof value === "object") {
    if (typeof value.exists === "boolean") return value.exists;
    if (typeof value.inUse === "boolean") return value.inUse;
    if (typeof value.emailInUse === "boolean") return value.emailInUse;
    if (typeof value.phoneInUse === "boolean") return value.phoneInUse;
    if (typeof value.data === "boolean") return value.data;
    if (typeof value.result === "boolean") return value.result;
  }
  return null;
};

export const normalizeBusinessProfileText = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

export const findBusinessProfileId = (items, idKey, label) => {
  const normalizedLabel = normalizeBusinessProfileText(label);
  if (!Array.isArray(items) || !normalizedLabel) return "";

  const match =
    items.find(
      (item) =>
        normalizeBusinessProfileText(item?.description) === normalizedLabel,
    ) ||
    items.find((item) => {
      const normalizedDescription = normalizeBusinessProfileText(
        item?.description,
      );
      return (
        normalizedDescription &&
        (normalizedDescription.includes(normalizedLabel) ||
          normalizedLabel.includes(normalizedDescription))
      );
    });

  return String(match?.[idKey] || "").trim();
};

export const normalizeBase64Data = (value) => {
  const rawValue = String(value || "").trim();
  if (!rawValue) return "";

  const normalizedValue = rawValue
    .replace(/^data:[^;]+;base64,/i, "")
    .replace(/\s+/g, "");

  return /^[A-Za-z0-9+/]+={0,2}$/.test(normalizedValue) ? normalizedValue : "";
};

export const getExtensionFromFile = (file) => {
  const type = String(file?.type || "").toLowerCase();
  const name = String(file?.name || "").toLowerCase();

  if (type.includes("png") || name.endsWith(".png")) return "png";
  if (type.includes("webp") || name.endsWith(".webp")) return "webp";
  if (type.includes("pdf") || name.endsWith(".pdf")) return "pdf";
  return "jpg";
};

export const fileToPickedDocument = (file, meta) =>
  new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error("No file selected."));
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const data = normalizeBase64Data(reader.result);
      if (!data) {
        reject(new Error("Selected file is not a valid base64 file."));
        return;
      }

      resolve({
        attachmentStatus: "DEFAULT",
        attachmentType: meta.attachmentType,
        countryName: meta.countryName || "Lebanon",
        customPath: null,
        data,
        extension: getExtensionFromFile(file),
        objectName: meta.objectName,
        registrationNumber: meta.registrationNumber || null,
        userName: meta.userName || "system",
        previewUri: URL.createObjectURL(file),
        label: file.name || meta.label,
      });
    };
    reader.onerror = () => reject(new Error("Could not read this file."));
    reader.readAsDataURL(file);
  });

export const cleanDocument = (document) => ({
  attachmentStatus: document.attachmentStatus,
  attachmentType: document.attachmentType,
  countryName: document.countryName,
  customPath: null,
  data: document.data,
  extension: document.extension,
  objectName: document.objectName,
  registrationNumber: document.registrationNumber ?? null,
  userName: document.userName,
});

export const extractRegisteredUser = (response) =>
  response?.data?.data ?? response?.data?.result ?? response?.data ?? {};

export const extractUserId = (source, jwtPayload = {}) =>
  String(
    source?.id ||
      source?.userID ||
      source?.userId ||
      source?.UserID ||
      source?.user?.id ||
      source?.user?.userID ||
      source?.user?.userId ||
      jwtPayload?.userId ||
      jwtPayload?.UserId ||
      jwtPayload?.UserID ||
      jwtPayload?.userID ||
      jwtPayload?.sub ||
      jwtPayload?.id ||
      "",
  ).trim();

export const extractCompanyId = (source) => {
  if (Array.isArray(source)) return extractCompanyId(source[0]);
  if (!source || typeof source !== "object") return "";

  return String(
    source.companyID ||
      source.companyId ||
      source.companyUUID ||
      source.companyUuid ||
      source.companyGUID ||
      source.companyGuid ||
      source.companyCode ||
      (source.id && source.companyName ? source.id : "") ||
      "",
  ).trim();
};
